import { ref } from 'vue'

export const useSavedTableColumns = (columnSaveKey) => {
  console.log('init saved table columns')
  const { $res } = useNuxtApp()
  const savedOrder = ref(null)
  const savedWidths = ref(null)
  const columnsLoading = ref(false)
  const fetchSavedOrder = async () => {
    columnsLoading.value = true
    const res = await $res.fetch.columnFields(columnSaveKey)
    if (res) {
      savedOrder.value = res
    }
    columnsLoading.value = false
  }
  const fetchSavedWidths = async () => {
    columnsLoading.value = true
    const res = await $res.fetch.columnFields(columnSaveKey + '_width')
    if (res) {
      savedWidths.value = res.reduce((acc, curr) => ({ ...acc, [curr.key]: curr.width }), {})
    }
    columnsLoading.value = false
  }
  if (!savedOrder.value) {
    fetchSavedOrder()
  }
  if (!savedWidths.value) {
    fetchSavedWidths()
  }
  const saveColumnWidth = (key, width) => {
    savedWidths.value = { ...savedWidths.value, [key]: width }
    const payload = Object.entries(savedWidths.value).map(([key, width]) => ({ key, width }))
    $res.set.columnFields(columnSaveKey + '_width', payload)
  }
  const saveColumnOrder = (data) => {
    savedOrder.value = data
    // editColumn component does the API calls... for now
  }
  return { savedOrder, savedWidths, columnsLoading, saveColumnWidth, saveColumnOrder }
}
